import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_rugs: FaireCategoryEntity = {
  token: "cat_accents-rugs",
  type: "category",
  name: "Rugs & doormats",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/rugs-doormats",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
